export default "__VITE_ASSET__DkGx8gxU__"